import React from "react";
import {
  convertStraight,
  currentDateOfTheMonth,
} from "../../common-data/Converts";

const ViewOfferLetter = ({ rowData }) => {
  return (
    <div className="container">
      <div className="col-12 text-right mt-4 flex-end">
        <span className="mt-2">
          Offer Date: <b>{convertStraight(currentDateOfTheMonth)}</b>
        </span>
      </div>
      <div className="text-center">
        <h5>
          <b>OFFER LETTER</b>
        </h5>
      </div>
      <div className="col-12">
        <b className="text-capitalize">{rowData?.name || "-"}</b>
        <p className="text-capitalize">{rowData?.address || "-"}</p>
        <p className="mt-1 text-capitalize">
          Dear <b>{rowData?.name || "-"}</b>,
        </p>
        <p>
          In continuation to our dialogue and verbal agreement, we are pleased
          to offer you the full-time role bearing the designation of{" "}
          <b className="text-capitalize">
            {rowData?.account_type?.replace(/_/g, " ") || "-"}
          </b>
          . Your appointment will be commencing from{" "}
          <b>
            {rowData?.joining_date
              ? convertStraight(rowData.joining_date)
              : "-"}
          </b>
          . We are pleased to offer you an Annual Compensation of INR{" "}
          <b>₹{rowData?.salary || 0}</b> Per Annum. Your employment will be on
          probation for 2 Months in which your performance will be monitored
          closely and reviewed by your reporting manager.
        </p>
        <p className="mt-2">
          You will be reporting to Reporting Manager.
          <br />
          You will be stationed at Job Location.
          <br />
          You will be working from Monday to Saturday.
          <br />
        </p>
        <p>
          You are requested to mandatorily submit a copy of the following
          documents at the time of your joining:
          <br />
        </p>
        <p>
          ∙ 4 Passport Size Photographs
          <br />
          ∙ All relevant documents (Self-attested)
          <br />
          ∙ Aadhaar Card
          <br />
          ∙ PAN Card
          <br />
          ∙ References (Any Three)
          <br />
        </p>
        <p>
          Note: This offer is valid up to (one day after the offer date) till
          09:00 PM.
          <br />
          Please let us know if you have any questions or concerns. We hope that
          you will accept this offer
          <br />
          and join our team.
          <br />
          <br />
          Thanking you, <br />
          Yours Sincerely,
          <br />
          <b>WTF Private Limited</b>
        </p>
      </div>
    </div>
  );
};

export default ViewOfferLetter;
